/*jshint esversion: 6 */
import React, { Component }  from 'react';

import PropTypes    from 'prop-types';
import { observer } from "mobx-react";
import { withStyles } from '@material-ui/core/styles';

import store from '../stores/Store';

import Dialog         from '@material-ui/core/Dialog';
import DialogActions  from '@material-ui/core/DialogActions';
import DialogContent  from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle    from '@material-ui/core/DialogTitle';
import Button         from '@material-ui/core/Button';

const styles = {};

class MessageDialogInner extends Component {
  constructor() {
    super();
    this.state = {};
  }
  render() {
    return (
      <Dialog
        open={store.messageDialogInfo.open}
        onClose={e => store.closeMessageDialogOpen()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title"
          style={{textAlign: 'center'}}
        >
          提示
        </DialogTitle>
        <DialogContent 
        style={{minWidth: '400px'}}>
        <DialogContentText id="alert-dialog-description">
            {store.messageDialogInfo.dialogMsg}
        </DialogContentText>
        </DialogContent>
        <DialogActions>
        <Button onClick={ e => store.closeMessageDialogOpen()} color="primary">
            关闭
        </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const MessageDialog= observer(MessageDialogInner);

MessageDialog.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MessageDialog);
